<template>
    <div>
        <span v-show="alias == null" v-html="title"></span>
        <span v-show="alias != null" v-html="alias"></span>
    </div>
</template>
<script>
export default {
    name: 'SubDetailElement',
    props: {
        sign: String,
        value: Object,
        title: String,
        type: String,
        alias: String,
    },
    data() {
        return {}
    },
    watch: {},
    mounted() {
        this.init()
    },
    methods: {
        init() {}
    }
}
</script>
<style lang="scss">
.sign {
    font-size: 11px;
    color: #ccc;
}
</style>